import React, { useState, useRef } from 'react';
import { Music, VolumeX } from 'lucide-react';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Destinations } from './components/Destinations';
import { ExperienceSelector } from './components/ExperienceSelector';
import { GuestWall } from './components/GuestWall';
import { Countdown } from './components/Countdown';
import { Footer } from './components/Footer';
export function App() {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const toggleMusic = () => {
    if (isPlaying) {
      audioRef.current?.pause();
    } else {
      audioRef.current?.play();
    }
    setIsPlaying(!isPlaying);
  };
  return <div className="min-h-screen bg-rich-black text-white selection:bg-gold selection:text-rich-black" data-id="element-0">
      {/* Background Audio (Placeholder Afrobeat/Lounge track) */}
      <audio ref={audioRef} loop src="https://cdn.pixabay.com/download/audio/2022/05/27/audio_1808fbf07a.mp3?filename=lofi-study-112191.mp3" data-id="element-1" />

      {/* Floating Music Toggle */}
      <button onClick={toggleMusic} className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full glass-panel flex items-center justify-center text-white hover:text-gold hover:scale-110 transition-all shadow-2xl" aria-label="Toggle background music" data-id="element-2">
        {isPlaying ? <Music size={24} data-id="element-3" /> : <VolumeX size={24} data-id="element-4" />}
      </button>

      {/* Main Content Sections */}
      <main data-id="element-5">
        <Hero data-id="element-6" />
        <About data-id="element-7" />
        <Destinations data-id="element-8" />
        <ExperienceSelector data-id="element-9" />
        <GuestWall data-id="element-10" />
        <Countdown data-id="element-11" />
      </main>

      <Footer data-id="element-12" />
    </div>;
}